import React, { useEffect, useState } from 'react'
import { academylist, driverlist, listvehicle, vehchangeroute, vehchangeroutelist } from '../../../services/admin';
import Select from "react-select";
import { vehroutelist, vehtriplist } from '../../../services/master';
import moment from 'moment';
import { Modal } from 'react-bootstrap';
import { AgGridReact } from 'ag-grid-react';
import { toast } from 'react-toastify';

export const ChangeRoute = () => {
  const [filterProduct, setFilterProduct] = useState([]);
  const [vehlist, setVenList] = useState([]);

  const [vlist, setVList] = useState([]);
  const [vehid, setVehID] = useState([]);

  const [dlist, setDList] = useState([]);
  const [driverid, setDriverid] = useState("");

  const [rlist, setRList] = useState([]);
  const [routeid, setRouteID] = useState([]);

  const [tlist, setTList] = useState([]);
  const [tripid, setTripID] = useState("");

  const [vdate, setVDate] = useState("");

  const [alist, setAList] = useState([]);
  const [acaid, setAcaID] = useState("");


  const [remark, setRemark] = useState("");

  const columnDefs = [


    {
      headerName: "Vehicle",
      field: "vehicle_no",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Driver",
      field: "worker_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Route",
      field: "vehroute_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Date",
      field: "change_date",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },

    },
    {
      headerName: "Remark",
      field: "remarks",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Academy",
      field: "academy_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
  ];

  useEffect(() => {
    setVDate(moment(new Date()).format("YYYY-MM-DD"));

    academylist().then((res) => {
      if (res.status === true) {
        let arr = [];
        if (res.data.details.length > 0) {
          for (let i = 0; i < res.data.details.length; i++) {
            arr.push({
              value: res.data.details[i].id,
              label:
                res.data.details[i].name + " - " + res.data.details[i].code,
            });
          }
          setAList(arr);
        }
      }
    });

    if (localStorage.getItem("AAcademy") != null) {
      academylist().then((res) => {
        if (res.status === true) {
          let arr = [];
          if (res.data.details.length > 0) {
            for (let i = 0; i < res.data.details.length; i++) {
              if (res.data.details[i].id == localStorage.getItem("AAcademy")) {
                arr.push({
                  value: res.data.details[i].id,
                  label:
                    res.data.details[i].name + " - " + res.data.details[i].code,
                });
              }
              if (arr.length > 0) {
                setAcaID(arr[0]);
                listall(arr[0]);
              }
            }

          }
        }
      });
    } else {
      listall("");
    }
  }, [])
  function handleAcademy(e) {
    if (e !== null) {
      setAcaID(e);
      listall(e)
    } else {
      setAcaID("");
      listall("");
    }
  }

  function handleDriver(e) {
    if (e !== null) {
      setDriverid(e);
    } else {
      setDriverid("");
    }
  }

  function handleVehicle(e) {
    if (e !== null) {
      setVehID(e);
      const sdata = vehlist.find((item) => item.id == e.value);
      if (sdata !== undefined) {
        setDriverid({ value: sdata.driver_id, label: sdata.worker_name });
        setRouteID(sdata.vehicle_route);
      }
    } else {
      setVehID("");
      setDriverid("");
      setRouteID("");
    }
  }


  function listall(aid) {
    setVenList([]);
    setVList([]);
    setDList([]);
    setRList([]);
    setTList([]);
    setFilterProduct([]);
    const temp = new FormData();
    if (localStorage.getItem("Role") === "1" && aid !== "") {
      temp.append("academy_id", aid.value);
    }
    temp.append("status", 1);

    listvehicle(temp).then((res) => {
      if (res.status === true) {
        let arr = [];
        if (res.data.details.length > 0) {
          setVenList(res.data.details);

          for (let i = 0; i < res.data.details.length; i++) {
            arr.push({
              value: res.data.details[i].id,
              label:
                res.data.details[i].vehicle_no + " - " + res.data.details[i].worker_name,
            });
          }
          setVList(arr);
        }
      }
    })

    driverlist(temp).then((res) => {
      if (res.status === true) {
        let arr = [];
        if (res.data.details.length > 0) {
          for (let i = 0; i < res.data.details.length; i++) {
            arr.push({
              value: res.data.details[i].id,
              label:
                res.data.details[i].worker_name + " - " + res.data.details[i].employee_id + " (" + res.data.details[i].username + ")",

            });
          }
          setDList(arr);
        }
      }
    });

    vehroutelist(temp).then((res) => {
      if (res.status === true) {
        setRList(res.data);
      }
    });

    vehtriplist(temp).then((res) => {
      if (res.status === true) {
        setTList(res.data);
      }
    });

    vehchangeroutelist(temp).then((res) => {
      if (res.status === true) {
        const sdata = res.data.details.map((item) => ({ ...item, change_date: moment(item.change_date).format("DD-MM-YYYY") }));

        setFilterProduct(sdata);
      }
    })
  }

  const [show, setShow] = useState(false)
  const [errmsg, setErrMsg] = useState("");

  function handleshow() {
    setShow(true)
    setAcaID("");
    setVehID("");
    setVDate(moment(new Date()).format("YYYY-MM-DD"));
    setDriverid("");
    setRouteID("");
    setTripID("");
    setRemark("");
    setErrMsg("");
  }

  function handleclose() {
    setAcaID("");
    setVehID("");
    setVDate(moment(new Date()).format("YYYY-MM-DD"));
    setDriverid("");
    setRouteID("");
    setTripID("");
    setRemark("");
    setErrMsg("");
    setShow(false)
  }


  function handleSave(e) {
    e.preventDefault();
    let valid = "";
    if (localStorage.getItem("Role") === "1") {
      if (acaid === "") {
        setErrMsg("Please Select Academy");
        valid = "Please Select Academy";
      }
    } else {
      valid = "";
    }

    if (valid === "") {
      if (vehid !== "") {
        if (driverid !== "") {
          if (routeid !== "") {
            if (vdate !== "") {
              const temp = new FormData();
              temp.append("vehicle_id", vehid.value);
              temp.append("driver_id", driverid.value);
              temp.append("route_id", routeid);
              temp.append("change_date", vdate);
              temp.append("remarks", remark);
              if (localStorage.getItem("Role") === "1" && acaid !== "") {
                temp.append("academy_id", acaid.value);
              }
              vehchangeroute(temp).then((res) => {
                if (res.status === true) {
                  handleclose();
                  toast.success(res.message);
                  listall(acaid);
                } else {
                  toast.error(res.data.errors);
                }
              })
            } else {
              setErrMsg("Please Select Date");
            }
          } else {
            setErrMsg("Please Select Route");
          }

        } else {
          setErrMsg("Please Select Driver");
        }
      } else {
        setErrMsg("Please Select Vehicle");
      }
    }
  }

  return (
    <div>
      <div className="page-header">
        <h2 className="main-content-title tx-24 mg-b-5">Change Vehicle Route</h2>
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <a>Transport</a>
          </li>
          <li className="breadcrumb-item active" aria-current="page">Change Vehicle Route</li>

        </ol>
      </div>

      <div className="content-body mb-4">
        <div className="container-fluid">

          <div className="card">

            <div className="card-body">
              <div className="row">
                <div className="col-xl-6 col-sm-6">

                  {localStorage.getItem("Role") === "1" && (
                    <div className="mb-3">
                      <label className="form-label">
                        Select Academy
                        <span className="text-danger"> *</span>
                      </label>
                      <Select
                        className="default-select"
                        placeholder="Select Academy"
                        value={acaid}
                        options={alist}
                        onChange={handleAcademy}
                        isSearchable={true}
                        isClearable
                        hidden
                      />

                    </div>
                  )}
                </div>

                <div className="col-xl-6 col-sm-6">
                  <div className="text-right mt-2">
                    <a className="btn btn-success" onClick={handleshow} >Change Route</a>
                  </div>
                </div>

              </div>

              <div className="ag-theme-alpine ag-style mt-2">
                <AgGridReact
                  columnDefs={columnDefs}
                  rowData={filterProduct}
                  pagination="true"
                  paginationPageSize="10"
                  sortingOrder={["asc", "desc"]}
                  suppressDragLeaveHidesColumns={true}
                />
              </div>
              <Modal show={show} size="lg">
                <Modal.Header>
                  <Modal.Title>Change Route for Driver</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <div className="row">
                    {localStorage.getItem("Role") === "1" && (
                      <div className="col-xl-12 col-sm-12">
                        <div className="mb-3">
                          <label className="form-label">
                            Select Academy
                            <span className="text-danger"> *</span>
                          </label>
                          <Select
                            className="default-select"
                            placeholder="Select Academy"
                            value={acaid}
                            options={alist}
                            onChange={handleAcademy}
                            isSearchable={true}
                            isClearable
                            hidden
                          />

                        </div>
                      </div>
                    )}

                    <div className="col-xl-12 col-sm-12">
                      <div className="mb-6">
                        <label className="form-label">
                          Vehicle <span className="text-danger"> *</span>
                        </label>
                        <Select
                          className="default-select"
                          placeholder="Select Vehicle"
                          value={vehid}
                          options={vlist}
                          onChange={handleVehicle}
                          isSearchable={true}
                          isClearable
                          hidden
                        />
                      </div>
                    </div>
                    <div className="col-xl-12 col-sm-12">
                      <div className="mb-6">
                        <label className="form-label">
                          Driver <span className="text-danger"> *</span>
                        </label>
                        <Select
                          className="default-select"
                          placeholder="Select Driver"
                          value={driverid}
                          options={dlist}
                          onChange={handleDriver}
                          isSearchable={true}
                          isClearable
                          hidden
                        />
                      </div>
                    </div>



                    <div className="col-xl-12 col-sm-12">
                      <div className="mb-6">
                        <label className="form-label">
                          Route <span className="text-danger"> *</span>
                        </label>
                        <select className="default-select form-control wide" onChange={(e) => setRouteID(e.target.value)} value={routeid}>
                          <option value="" disabled>
                            Select Route
                          </option>
                          {rlist.map((item) => {
                            return (
                              <option value={item.id} key={item.id}>
                                {item.vehroute_name}
                              </option>
                            );
                          })

                          }
                        </select>
                      </div>
                    </div>


                    {/* <div className="col-xl-12 col-sm-12">
                                           <div className="mb-6">
                                               <label className="form-label">
                                                   Trip<span className="text-danger"> *</span>
                                               </label>
                                               <select className="default-select form-control wide" onChange={(e)=>setTripID(e.target.value)} value={tripid}>
                                                   <option value="" disabled>
                                                       Select Trip
                                                   </option>
                                                   {tlist.map((item) => {
                                                       return (
                                                           <option value={item.id} key={item.id}>
                                                               {item.vehtrip_name}
                                                           </option>
                                                       );
                                                   })
                                                       
                                                   }
                                               </select>
                                           </div>
                                       </div> */}
                    <div className="col-xl-12 col-sm-12">
                      <div className="mb-6">
                        <label className="form-label">
                          Date
                          <span className="text-danger"> *</span>
                        </label>
                        <input
                          className="form-control"
                          type="date"
                          onChange={(e) => setVDate(e.target.value)}
                          value={vdate}
                        />
                      </div>
                    </div>

                    <div className="col-xl-12 col-sm-12">
                      <div className="mb-6">
                        <label className="form-label">
                          Remark
                        </label>
                        <textarea rows="4" className="form-control" onChange={(e) => setRemark(e.target.value)} value={remark} placeholder='Enter Remark'></textarea>
                      </div>
                    </div>
                  </div>
                </Modal.Body>
                <Modal.Footer>
                  <a className="btn btn-secondary" onClick={handleclose}>
                    Close
                  </a>
                  <a className="btn btn-success" onClick={handleSave}>
                    Submit
                  </a>
                </Modal.Footer>
              </Modal>
            </div>

          </div>
        </div>
      </div>
    </div>
  )
}
